module.exports = __webpack_public_path__ + "img/icon_e52.a7f0f7ad.png";